var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5L7.5 12H1.5L3 16.5H9ZM9 16.5H12",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.75V9.375C9 7.9608 9 7.25368 8.56065 6.81434C8.1213 6.375 7.41421 6.375 6 6.375C4.58579 6.375 3.87868 6.375 3.43934 6.81434C3 7.25368 3 7.9608 3 9.375V9.75",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 9.75C14.25 10.5784 13.5784 11.25 12.75 11.25C11.9216 11.25 11.25 10.5784 11.25 9.75C11.25 8.92155 11.9216 8.25 12.75 8.25C13.5784 8.25 14.25 8.92155 14.25 9.75Z",
    stroke: "black",
    strokeWidth: 1.125
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3C7.5 3.82843 6.82843 4.5 6 4.5C5.17157 4.5 4.5 3.82843 4.5 3C4.5 2.17157 5.17157 1.5 6 1.5C6.82843 1.5 7.5 2.17157 7.5 3Z",
    stroke: "black",
    strokeWidth: 1.125
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.125H15C15.8284 13.125 16.5 13.7966 16.5 14.625V15C16.5 15.8284 15.8284 16.5 15 16.5H14.25",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadIcon);
export default __webpack_public_path__ + "static/media/lead-Icon.44c6c3828b65583a1a3186e26eac44d0.svg";
export { ForwardRef as ReactComponent };